export const specializedTeamData = [
    {
        leftImage: "./assets/imgs/nosotros/equipoEspecializado/1.png",
        rightImage: "./assets/imgs/nosotros/equipoEspecializado/2.png",
        title: {
            highlight: "EQUIPO",
            main: "ESPECIALIZADO",
        },
        description: `
        En <b>HISOL</b>, contamos con un equipo altamente capacitado y certificado en rope access para llevar a cabo maniobras especializadas de limpieza, mantenimiento y restauración en altura.
        <br/ > <br/ >
        Nuestro personal posee certificaciones internacionales como <b>IRATA</b> (Industrial Rope Access Trade Association) y <b>SPRAT</b> (Society of Professional Rope Access Technicians), garantizando operaciones seguras, eficientes y conforme a las mejores prácticas de la industria.
        <br/ > <br/ >
        Operamos bajo los estándares más estrictos de seguridad y calidad, cumpliendo con normativas en gestión de seguridad y salud en el trabajo y capacitaciones en protección contra caídas en altura. Además, en <b>HISOL</b> estamos en constante evolución, incorporando nuevas tecnologías, metodologías y certificaciones para seguir ofreciendo soluciones innovadoras y de alto nivel en trabajos verticales.
        <br/ > <br/ >
        Confíe en los expertos. Maximizamos la seguridad,minimizamos riesgos y garantizamos resultados excepcionales en cada proyecto.
      `,
    },
];

export const specializedTeamDataEn = [
    {
        leftImage: "./assets/imgs/nosotros/equipoEspecializado/1.png",
        rightImage: "./assets/imgs/nosotros/equipoEspecializado/2.png",
        title: {
            highlight: "TEAM",
            main: "SPECIALIZED",
        },
        description: `
        At <b>HISOL</b>, we have a highly trained and certified rope access team to carry out specialized high-altitude cleaning, maintenance, and restoration maneuvers.
        <br/><br/>
        Our personnel hold international certifications such as <b>IRATA</b> (Industrial Rope Access Trade Association) and <b>SPRAT</b> (Society of Professional Rope Access Technicians), ensuring safe and efficient operations that meet the industry’s best practices.
        <br/><br/>
        We operate under the strictest safety and quality standards, complying with occupational health and safety regulations and fall-protection training. Additionally, at <b>HISOL</b> we are constantly evolving—incorporating new technologies, methodologies, and certifications—to continue offering innovative, top-level solutions in vertical work.
        <br/><br/>
        Trust the experts: we maximize safety, minimize risk, and guarantee exceptional results on every project.
      `,
    },
];

